import type { CSSProperties } from "react";
import type { Task } from "../types";

// Multiplication by an odd number is a permutation of all 24-bit RGB values.
// The database allocates the ordinal under a lock; clients never choose at random.
export function projectColor(ordinal: number) {
  if (!Number.isInteger(ordinal) || ordinal < 1 || ordinal > 0xffffff)
    throw new Error("Нет свободного цвета проекта");
  return `#${((ordinal * 0x9e3779) % 0x1000000).toString(16).padStart(6, "0")}`;
}

export function calendarTaskStyle(
  task: Pick<Task, "status" | "done_date">,
  color?: string | null,
): CSSProperties {
  const completed = task.status === "completed" || !!task.done_date;
  const accent = completed
    ? "#888888"
    : /^#[0-9a-f]{6}$/i.test(color ?? "")
      ? color!
      : "var(--primary)";
  return {
    borderColor: accent,
    borderInlineStartWidth: 3,
    backgroundColor: `color-mix(in srgb, ${accent} 18%, var(--card))`,
    color: completed ? "var(--muted-foreground)" : "var(--foreground)",
  };
}

export const projectSurfaceStyle = (color?:string|null):CSSProperties => calendarTaskStyle({status:"new"},color);
